/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable object-shorthand */
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Button,
  Alert,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import AddIcon from "@mui/icons-material/Add";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
// import AbideService from "../../../../../services/i-abide/form-service";
import useAxiosPrivate from "../../../../../contexts/interceptors/axios";
// import { useStateContext } from "../../../../../contexts/ContextProvider";
import AddDirectoryModal from "../../../../../modals/i-abide/AddDirectory";

export default function Directories() {
  const [data, setData] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // State for dialog
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  // const navigate = useNavigate(); // Hook for navigation
  const axiosPrivate = useAxiosPrivate();
  // const { auth } = useStateContext();

  const handleGetAll = () => {
    // setLoading(true);
    setError("");

    axiosPrivate
      .get(`/I-Abide/getAllDirectories`)
      .then((e) => {
        setData(e.data);
      })
      .catch((error) => {
        setError("Failed to fetch directories");
        setSnackbarMessage("Failed to fetch directories. Please try again.");
        setOpenSnackbar(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Handle folder click to navigate to the Subdirectories page
  const handleDirectoryClick = (directory) => {
    console.log("Navigating to subdirectories with:", directory);
    const { id, directoryName } = directory;
    // Pass the parent folder ID and directory name to the Subdirectories page
    navigate("/subdirectories", {
      state: { parentDirectoryId: id, subdirectoryName: directoryName },
    });
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  useEffect(() => {
    handleGetAll();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box p={1}>
      <Box sx={{ p: 2, background: "black" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            gap: 2,
          }}
        >
          <FolderCopyIcon style={{ fontSize: 50, color: "#ecfc08" }} />
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Poppins",
              fontWeight: "bold",
              color: "white",
            }}
          >
            DIRECTORIES MANAGEMENT
          </Typography>
        </Box>
      </Box>

      <Box display="flex" justifyContent="flex-end" sx={{ p: 3 }}>
        <Button
          variant="outlined"
          color="primary"
          endIcon={<AddIcon />}
          sx={{
            fontSize: "1.2rem",
            padding: "12px 24px",
            minWidth: "180px",
            "&:hover": {
              backgroundColor: "#007BFF",
              borderColor: "#0056b3",
              color: "#fff",
            },
          }}
          onClick={() => setOpenModal(true)}
        >
          ADD DIRECTORY
        </Button>
      </Box>

      <AddDirectoryModal
        open={openModal}
        handleClose={() => setOpenModal(false)}
        updateTableFunction={handleGetAll}
      />

      <Grid container spacing={1}>
        {data.length > 0 ? (
          data.map((directory) => (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={directory.id}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                textAlign="center"
              >
                <IconButton
                  color="primary"
                  onClick={() => handleDirectoryClick(directory)}
                >
                  <FolderSharedIcon style={{ fontSize: 100 }} />
                </IconButton>
                <Typography variant="subtitle1">
                  {directory.directoryName}
                </Typography>
              </Box>
            </Grid>
          ))
        ) : (
          <Typography>No directories found</Typography>
        )}
      </Grid>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert severity="error" onClose={handleCloseSnackbar}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
